export enum MessageType {
	Notification = 1,
	Request = 2,
	Response = 3
}
